// extracted by mini-css-extract-plugin
export const click = "bh_cD";
export const picture = "bh_cF";